const PRODUCTS_COLUMN_START_INDEX = 11;
const PRODUCTS_COLUMN_END_INDEX = 17;

export { PRODUCTS_COLUMN_START_INDEX, PRODUCTS_COLUMN_END_INDEX };
